export default function TableCaption() {
    return (
        <caption className={"caption-top"}>Zoekertjes</caption>
    );
};